/* OOTD quick view — fetches a product through the Section Rendering API
   and adds to the cart without leaving the grid. Self-bootstrapping. */
(function () {
  if (window.__ootdQV) return;
  window.__ootdQV = true;

  var mask, sheet, body, lastFocus, busy = false;

  function build() {
    mask = document.createElement('div');
    mask.className = 'ootd-qvmask';
    mask.setAttribute('data-ootd-qv-mask', '');

    sheet = document.createElement('div');
    sheet.className = 'ootd-qvsheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Quick view');
    sheet.innerHTML =
      '<button type="button" class="ootd-qvsheet__x" data-ootd-qv-close aria-label="Close quick view">&times;</button>' +
      '<div data-ootd-qv-slot><div class="ootd-qvsheet__load">Loading</div></div>';

    document.body.appendChild(mask);
    document.body.appendChild(sheet);
    body = sheet.querySelector('[data-ootd-qv-slot]');

    mask.addEventListener('click', close);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ootd-qv-close]')) close();
    });
  }

  function open() {
    if (!mask) build();
    lastFocus = document.activeElement;
    mask.classList.add('is-on');
    sheet.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!mask) return;
    mask.classList.remove('is-on');
    sheet.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('is-on')) close();
  });

  /* ---- open from any card ------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ootd-qv]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    var url = trigger.getAttribute('data-ootd-qv');
    if (!url) return;

    open();
    body.innerHTML = '<div class="ootd-qvsheet__load">Loading</div>';

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=ootd-quickview')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-ootd-qv-body]');
        if (!node) { window.location.href = url; return; }
        body.innerHTML = '';
        body.appendChild(node);
        sync();
        var first = body.querySelector('.ootd-qv__size:not(.is-out)');
        if (first) first.focus();
      })
      .catch(function () { window.location.href = url; });
  }, true);

  /* ---- size selection ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ootd-qv-variant]');
    if (!btn || !sheet || !sheet.contains(btn)) return;
    if (btn.classList.contains('is-out') || btn.disabled) return;
    body.querySelectorAll('[data-ootd-qv-variant]').forEach(function (b) {
      b.classList.remove('is-on');
    });
    btn.classList.add('is-on');
    sync();
  });

  function selected() {
    return body ? body.querySelector('[data-ootd-qv-variant].is-on') : null;
  }

  function sync() {
    var add = body.querySelector('[data-ootd-qv-add]');
    var note = body.querySelector('[data-ootd-qv-stock]');
    var sel = selected();
    if (!add) return;

    if (!sel) {
      add.textContent = 'Select a size';
      add.disabled = true;
      if (note) note.textContent = '';
      return;
    }
    add.textContent = 'Add to bag';
    add.disabled = false;

    if (note) {
      var qty = parseInt(sel.getAttribute('data-qty') || '0', 10);
      var tracked = (sel.getAttribute('data-track') || '') !== '';
      note.textContent = tracked && qty > 0 && qty <= 3
        ? (qty === 1 ? 'Last one in this size' : 'Only ' + qty + ' left in this size')
        : '';
    }
  }

  /* ---- add to cart --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ootd-qv-add]');
    if (!add || !sheet || !sheet.contains(add) || busy) return;
    var sel = selected();
    if (!sel) return;

    busy = true;
    var label = add.textContent;
    add.textContent = 'Adding';
    add.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(sel.getAttribute('data-ootd-qv-variant')), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        busy = false;
        if (data.status) {
          add.textContent = data.description || 'Unavailable';
          add.disabled = false;
          return;
        }
        paint(data.sections);
        add.textContent = 'Added';
        setTimeout(function () {
          close();
          add.textContent = label;
          add.disabled = false;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 500);
      })
      .catch(function () {
        busy = false;
        add.textContent = label;
        add.disabled = false;
      });
  });

  function paint(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      if (!html) return;
      var incoming = new DOMParser().parseFromString(html, 'text/html');
      var src = incoming.querySelector('.shopify-section') || incoming.body.firstElementChild;
      var target =
        document.getElementById('shopify-section-' + key) ||
        document.querySelector('#' + key) ||
        document.querySelector('.' + key);
      if (src && target) target.innerHTML = src.innerHTML;
    });
  }
})();
